function removeAllQueryParams() {
  const url = new URL(window.location.href);

  url.search = '';
  window.history.replaceState({}, '', url.toString());

  return url.toString();
}

export default removeAllQueryParams;
